/**
 * Full-width (全角) ↔ Half-width (半角) character conversion.
 * Converts ASCII printable characters (0x21–0x7E) to their
 * full-width Unicode equivalents (0xFF01–0xFF5E) and vice versa.
 */

const FULL_WIDTH_OFFSET = 0xfee0;

export const toFullWidth = (char: string): string => {
  return char.replace(/[!-~]/g, c => String.fromCharCode(c.charCodeAt(0) + FULL_WIDTH_OFFSET));
};

export const toHalfWidth = (char: string): string => {
  return char.replace(/[！-～]/g, c => String.fromCharCode(c.charCodeAt(0) - FULL_WIDTH_OFFSET));
};

